// @flow

import qs from 'qs';
import Api from '../ApiBase';

const getListParams = () => qs.stringify({
  page: {
    limit: 100
  }
});

class IndustriesApi extends Api {
  fetch = async () => {
    const json = await this.request(`search_industries?${getListParams()}`);
    const data = await this.deserialize(json);

    return { data };
  }
}

export default new IndustriesApi();
